import { useEffect } from 'react';
import { DELAY } from '../../../constants/GeneralConstants';
import { ScrollUtil } from '../../../util/ScrollUtil';
const collectErrorPaths = (err, path = '') => {
    const paths = [];
    Object.entries(err).forEach(([key, value]) => {
        if (value !== null && typeof value === 'object') {
            const currentPath = path ? `${path}.${key}` : key;
            if ('type' in value) {
                paths.push(currentPath);
            }
            else {
                paths.push(...collectErrorPaths(value, currentPath));
            }
        }
    });
    return paths;
};
const scrollToFirstError = (err) => {
    const elements = collectErrorPaths(err)
        .map(path => document.getElementById(path))
        .filter((el) => el !== null);
    if (elements.length === 0)
        return false;
    const topmost = elements.reduce((best, el) => el.getBoundingClientRect().top + window.scrollY < best.getBoundingClientRect().top + window.scrollY ? el : best);
    ScrollUtil.scrollToElement(topmost, true, 'center');
    return true;
};
export function useScrollToFirstFormError(formState, isScrollingEnabled = false) {
    useEffect(() => {
        if (Object.keys(formState.errors).length === 0 || !isScrollingEnabled) {
            return;
        }
        setTimeout(() => {
            // Retry once if elements are not in the DOM yet (conditionally rendered fields
            // that only mount after validation errors appear, as in CollectStore/PickupPoint)
            if (!scrollToFirstError(formState.errors)) {
                setTimeout(() => scrollToFirstError(formState.errors), DELAY.DELAY_250);
            }
        }, DELAY.DELAY_250);
    }, [formState.errors, isScrollingEnabled]);
}
